import type { NavItem } from '@/components/layout/Sidebar';

export const QUICK_ACCESS_STORAGE_KEY = 'org_quick_access_recent_paths_v1';
export const QUICK_ACCESS_LIMIT = 10;

export function readRecentPaths(): string[] {
  try {
    const raw = localStorage.getItem(QUICK_ACCESS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((p): p is string => typeof p === 'string') : [];
  } catch {
    return [];
  }
}

export function writeRecentPaths(paths: string[]) {
  localStorage.setItem(
    QUICK_ACCESS_STORAGE_KEY,
    JSON.stringify(paths.slice(0, QUICK_ACCESS_LIMIT)),
  );
}

export function recordRecentPath(path: string, current: string[]): string[] {
  const next = [path, ...current.filter((p) => p !== path)].slice(0, QUICK_ACCESS_LIMIT);
  writeRecentPaths(next);
  return next;
}

export function resolveQuickAccessItems(
  recentPaths: string[],
  allItems: NavItem[],
): NavItem[] {
  const byPath = new Map(allItems.map((item) => [item.to, item]));
  return recentPaths
    .map((path) => byPath.get(path))
    .filter((item): item is NavItem => Boolean(item));
}
